var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-card',{attrs:{"heading":_vm.$t('title.noInternetConnection'),"description":_vm.$t('subtitle.checkAndTryAgain'),"error-message":_vm.errorMessage},on:{"submit":_vm.handleSubmit},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('button-primary',{attrs:{"text":_vm.$t('button.tryAgain')}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }